import bgImage from '@assets/pay-bg.png';
import { Flex } from '@components/ui/atoms/Flex';
import { memo, useMemo } from 'react';
import { Outlet } from 'react-router';

export const PayLayout: React.FCWithChildren = memo((props) => {
  const backgroundStyles = useMemo(
    () => ({
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }),
    []
  );

  return (
    <Flex
      w="full"
      h="full"
      as="main"
      position="relative"
      overflow="hidden"
      css={{
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          ...backgroundStyles,
          zIndex: 0,
        },
      }}
    >
      <Flex
        display="flex"
        flexDirection="column"
        flex="1"
        minHeight={0}
        width="full"
        height="full"
        position="relative"
        zIndex={1}
        overflowY="auto"
        overflowX="hidden"
        py="16px"
        px={{ base: '16px', md: '20px' }}
        data-scroll-container
        css={{
          WebkitOverflowScrolling: 'touch',
          /* Android Chrome fix: ensure proper scrolling */
          overscrollBehavior: 'contain',
          touchAction: 'pan-y',
        }}
      >
        <Flex
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="full"
          color="body.dark"
          css={{
            '@media (max-width: 767px)': {
              paddingBottom: '48px !important',
            },
            '@media (min-width: 768px) and (max-width: 1023px)': {
              paddingBottom: '32px !important',
            },
          }}
        >
          <Outlet />
          {props.children}
        </Flex>
      </Flex>
    </Flex>
  );
});

PayLayout.displayName = 'PayLayout';
